import { matchRoutes } from 'react-router';

export const ROUTE_PATHS = {
    home: '/',
    recordings: '/recordings',
    sharedRecording: '/recordings/s/:token',
    custom: '/custom',
    legacyRoom: '/rooms/:roomName',
    egressTemplate: '/egress-template',
    room: '/:roomName',
} as const;

const ROUTES = Object.values(ROUTE_PATHS).map((path) => ({ path }));

export function roomNameFromPath(pathname: string): string | null {
    const match = matchRoutes(ROUTES, pathname)?.at(-1);
    const path = match?.route.path;
    if (path !== ROUTE_PATHS.room && path !== ROUTE_PATHS.legacyRoom) return null;
    return match?.params.roomName ?? null;
}
